import { AppState } from '../types'
import { LanguageCode } from '../../../types/types'

export const getSelectedLanguage = (state: AppState): LanguageCode | null => {
  return state.region.selectedLanguage || null
}
